import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from "react-router-dom";
import { Link } from 'react-router-dom';



function AdmissionRules() {

  const { id } = useParams();

  const navigate = useNavigate();
  const [checkboxes, setCheckboxes] = useState({
    termsChecked: false,
    privacyChecked: false
  });
  const [hasDownloadedProspectus, setHasDownloadedProspectus] = useState(false);




  const handleCheckboxChange = (e) => {
    const { name, checked } = e.target;
    setCheckboxes(prev => ({
      ...prev,
      [name]: checked
    }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!hasDownloadedProspectus) {
      alert("Please view/download at least one Prospectus (English or Kannada) before proceeding.");
      return;
    }

    if (!checkboxes.termsChecked || !checkboxes.privacyChecked) {
      alert("Please agree to both conditions before proceeding.");
      return;
    }

    setCheckboxes({
      termsChecked: false,
      privacyChecked: false
    });

    navigate(`/payment/${id}`);
  };



  return (
    <>
      <div className="w-full min-h-screen flex items-center justify-center bg-gray-50 px-4">
        <div className="w-full max-w-2xl bg-white rounded-lg shadow-md p-6">
          <h2 className="text-xl font-semibold text-center mb-4">Admission Rules</h2>

          <div className="flex flex-col sm:flex-row sm:justify-between gap-5 w-full py-5">
            {/* Download Kannada Prospectus */}
            <div className="w-full sm:w-1/2 mt-3">
              <a href="/Kannada-Prospectus.pdf" target="_blank"
                onClick={() => setHasDownloadedProspectus(true)}
                className="block sm:inline-block w-full bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200 text-center"
              >
                Download Kannada Prospectus
              </a>
            </div>
            {/* Download Prospectus */}
            <div className="w-full sm:w-1/2 mt-3">
              <a href="/English-Prospectus.pdf" target="_blank"
                onClick={() => setHasDownloadedProspectus(true)}
                className="block sm:inline-block w-full bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200 text-center"
              >
                Download English Prospectus
              </a>
            </div>


          </div>


          <form onSubmit={handleSubmit} className="grid grid-cols-1 sm:grid-cols-2 gap-4">

            {/* condition checks */}
            <div className='sm:col-span-2'>
              <input
                className="w-6 h-6"
                type="checkbox"
                name="termsChecked"
                checked={checkboxes.termsChecked}
                onChange={handleCheckboxChange}
              />
              <label> I do hereby declare that all the particulars given above by me are true and correct to the best of my knowledge.</label>
            </div>

            <div className='sm:col-span-2'>
              <input
                className="w-6 h-6"
                type="checkbox"
                name="privacyChecked"
                checked={checkboxes.privacyChecked}
                onChange={handleCheckboxChange}
              />
              <label> I undertake to abide by the rules and regulations of the institution with respect to the admission procedures, academic, sports and extracurricular activities, code of conduct, discipline and moral education as given in the prospectus. In the event of any act of indiscipline on my part the decision of the concerned authorities shall be final and binding on me. I endorse the above statements.</label>
            </div>

            <div className="mt-3">
              <button
                type="submit"
                className="w-full bg-blue-500 hover:bg-blue-700 text-white font-semibold py-2 px-4 rounded-lg transition duration-200"
              >
                Proceed to Payment
              </button>
            </div>


          </form>
        </div>
      </div>
    </>
  )
}

export default AdmissionRules